import React, { useState, useEffect, useRef } from 'react';
import style from './MainHospitalSetting.module.css';
import { useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';

import HeadSub from '../../../../components/comm/HeadSub';

const MainHospitalSetting = () => {

    const navigate = useNavigate();
    
    return (
        <>
            <HeadSub title="대표 병원 설정" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap'>

                    <div className={style['content-box']}>
                        <div className={style['top-txt']}>
                            <span> 대표 병원으로 설정할 병원을 선택해주세요</span>
                        </div>
                        
                        <div className={style['select-list-box']}>
                            <p>병원 선택</p>
                            <div className={style['main-select-box']}>
                                <p>서울성모병원</p>
                                <span className={style['main-mark']}>현재 대표 병원</span>
                            </div>

                            <ul className={style['select-list-ul']}>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="hospital1" name='hospital-select'/>
                                        <label htmlFor="hospital1">
                                            <span>여의도성모병원</span>
                                        </label>
                                    </div>  
                                </li>
                                <li>
                                    <div className='radio-selectbox'>
                                        <input type="radio" id="hospital2" name='hospital-select'/>
                                        <label htmlFor="hospital2">
                                            <span>은평성모병원</span>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="bottom-fixed-box" data-border-line="top">
                            <div className="inner-box">

                                <div className='btn-layout' data-btn-num="2">
                                    <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={() => navigate(-1)}>
                                        <span>취소</span>
                                    </button>
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                        <span>선택 완료</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            
        </>
    );
};

export default MainHospitalSetting;
